(function () {
  'use strict';

  if (window.__merlonsCollectionToolbarLoaded) return;
  window.__merlonsCollectionToolbarLoaded = true;

  var activeSearchRequest = 0;
  var activeSearchController = null;
  var collectionItemsCache = new Map();
  var searchItemsCache = new Map();
  var queryInfiniteState = null;
  var queryPaginationLabels = null;
  var categoryHierarchyState = null;
  var categoryHierarchyGeneration = 0;
  var openSheetState = null;
  var openCategorySheetState = null;
  var stickyOffsetFrame = 0;
  var mountingFilterSortObserver = null;
  var mountingFilterSortRoot = null;
  var mountingFilterSortFrame = 0;

  function getRoot() {
    return document.getElementById('main-collection-filters');
  }

  function isAllProductsCollection() {
    var root = getRoot();
    return Boolean(root && root.getAttribute('data-merlons-collection-handle') === 'all');
  }

  function isSearchResultsPage() {
    var root = getRoot();
    return Boolean(root && root.classList.contains('page-search'));
  }

  function getSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  function getCategorySources() {
    var root = getRoot();
    var sourceNode = root && root.querySelector('[data-merlons-category-sources]');
    var rawSources = [];
    if (sourceNode) {
      try {
        rawSources = JSON.parse(sourceNode.textContent || '[]');
      } catch (error) {
        console.error('[Merlons category hierarchy]', error);
      }
    }

    if (!Array.isArray(rawSources) || !rawSources.length) {
      rawSources = [{
        handle: root ? root.getAttribute('data-merlons-collection-handle') || '' : '',
        url: collectionDataPath()
      }];
    }

    var seen = new Set();
    return rawSources.map(function (source) {
      if (!source || typeof source !== 'object') return null;
      var handle = normalizeQuery(source.handle);
      var sourceUrl;
      try {
        sourceUrl = new URL(source.url || '', window.location.origin);
      } catch (error) {
        return null;
      }
      var path = sourceUrl.pathname;
      var key = handle || path;
      if (!key || seen.has(key)) return null;
      seen.add(key);
      return { handle: handle, url: path };
    }).filter(Boolean);
  }

  function hasCategoryDescendants() {
    var root = getRoot();
    return Boolean(
      root &&
      root.getAttribute('data-merlons-hierarchy-active') === 'true' &&
      getCategorySources().length > 1
    );
  }

  window.merlonsGetCollectionCategorySources = getCategorySources;

  function getSelectedOfferModes(params) {
    var source = params || getSearchParams();
    if (typeof window.merlonsGetSelectedOfferModes === 'function') {
      return window.merlonsGetSelectedOfferModes(source);
    }
    var seen = Object.create(null);
    return source.getAll('merlons_offer').filter(function (value) {
      if ((value !== 'discount' && value !== 'liquidation') || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function elementBooleanAttribute(element, name, fallback) {
    var value = element.getAttribute(name);
    if (value === 'true') return true;
    if (value === 'false') return false;
    return fallback;
  }

  function normalizeQuery(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function setBoundedCache(cache, key, value, limit) {
    if (cache.has(key)) cache.delete(key);
    cache.set(key, value);
    while (cache.size > limit) {
      cache.delete(cache.keys().next().value);
    }
  }

  function getCurrentQuery() {
    return normalizeQuery(getSearchParams().get('q'));
  }

  function setStatus(message) {
    var root = getRoot();
    var status = root && root.querySelector('[data-merlons-collection-status]');
    if (status) status.textContent = message || '';
  }

  function getStatusLabel(name, count) {
    var root = getRoot();
    var label = root ? root.getAttribute(name) || '' : '';
    return label.replace('[count]', String(count == null ? '' : count));
  }

  function mountingFilterValueRank(value) {
    var label = normalizeQuery(value).toLowerCase();
    var isUnder = label.indexOf('ქვემოდან') !== -1 ||
      label.indexOf('ამოსაკრავი') !== -1 ||
      label.indexOf('ამოსმადი') !== -1 ||
      label.indexOf('undermount') !== -1 ||
      label.indexOf('нижний') !== -1;
    var isTop = label.indexOf('ზემოდან') !== -1 ||
      label.indexOf('ჩასასმელი') !== -1 ||
      label.indexOf('topmount') !== -1 ||
      label.indexOf('верхний') !== -1;
    if (isUnder && !isTop) return 0;
    if (isTop && !isUnder) return 1;
    if (isUnder && isTop) return 2;
    return 99;
  }

  function sortMountingFilterValues() {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('.js-filter[data-filter-kind="mounting"] .facets__list').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      var ranked = items.map(function (item, index) {
        var label = normalizeQuery((item.querySelector('.filter-option-value') || {}).textContent || '').toLowerCase();
        return { item: item, rank: mountingFilterValueRank(label), index: index };
      });
      ranked.sort(function (a, b) { return a.rank - b.rank || a.index - b.index; });
      var changed = ranked.some(function (entry, index) { return entry.item !== items[index]; });
      if (!changed) return;
      var fragment = document.createDocumentFragment();
      ranked.forEach(function (entry) { fragment.appendChild(entry.item); });
      list.appendChild(fragment);
    });
  }

  function queueMountingFilterSort() {
    if (mountingFilterSortFrame) return;
    mountingFilterSortFrame = window.requestAnimationFrame(function () {
      mountingFilterSortFrame = 0;
      sortMountingFilterValues();
    });
  }

  function observeMountingFilterOrder() {
    var root = getRoot();
    sortMountingFilterValues();
    if (root === mountingFilterSortRoot && mountingFilterSortObserver) return;
    if (mountingFilterSortObserver) mountingFilterSortObserver.disconnect();
    mountingFilterSortObserver = null;
    mountingFilterSortRoot = root;
    if (!root || typeof MutationObserver !== 'function') return;
    mountingFilterSortObserver = new MutationObserver(function (mutations) {
      var changed = mutations.some(function (mutation) {
        return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
      });
      if (changed) queueMountingFilterSort();
    });
    mountingFilterSortObserver.observe(root, { childList: true, subtree: true });
  }

  function disconnectMountingFilterOrderObserver() {
    if (mountingFilterSortObserver) mountingFilterSortObserver.disconnect();
    mountingFilterSortObserver = null;
    mountingFilterSortRoot = null;
    if (mountingFilterSortFrame) window.cancelAnimationFrame(mountingFilterSortFrame);
    mountingFilterSortFrame = 0;
  }

  function syncSearchInput() {
    var root = getRoot();
    if (!root) return;
    var input = root.querySelector('[data-merlons-collection-search-input]');
    var clear = root.querySelector('[data-merlons-collection-search-clear]');
    if (!input) return;
    var query = getCurrentQuery();
    if (document.activeElement !== input || input.value !== query) input.value = query;
    if (clear) clear.hidden = !normalizeQuery(input.value);
  }

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (element) {
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0;
      }
    );
  }

  function trapSheetFocus(event, sheet) {
    if (event.key !== 'Tab') return;
    var focusables = getFocusableElements(sheet);
    if (!focusables.length) {
      event.preventDefault();
      sheet.focus({ preventScroll: true });
      return;
    }
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (!sheet.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus({ preventScroll: true });
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  function syncStickyOffset() {
    stickyOffsetFrame = 0;
    var root = getRoot();
    if (!root) return;
    var offset = 0;
    var activeHeaders = document.querySelectorAll(
      '#header-sticky.sticky-header-active, .header-mobile.sticky-header-active .header-mobile-content'
    );
    activeHeaders.forEach(function (header) {
      var styles = window.getComputedStyle(header);
      var rect = header.getBoundingClientRect();
      if (styles.display === 'none' || styles.visibility === 'hidden' || rect.height <= 0 || rect.bottom <= 0) return;
      offset = Math.max(offset, Math.min(window.innerHeight, rect.bottom));
    });
    root.style.setProperty('--merlons-collection-sticky-top', Math.max(0, Math.round(offset)) + 'px');

    var mobileToolbar = root.querySelector('[data-merlons-collection-toolbar]');
    if (mobileToolbar) {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var anchor = root.querySelector('[data-merlons-collection-toolbar-anchor]');
      var wasStuck = mobileToolbar.classList.contains('is-mobile-stuck');
      if (!isMobile) {
        mobileToolbar.classList.remove('is-mobile-stuck');
        mobileToolbar.style.removeProperty('--merlons-toolbar-fixed-left');
        mobileToolbar.style.removeProperty('--merlons-toolbar-fixed-right');
        if (anchor) {
          anchor.classList.remove('is-reserving-space');
          anchor.style.removeProperty('height');
        }
        return;
      }

      /* Measure the stable anchor, not the toolbar whose compact state changes
         its own height. A small release buffer also prevents mobile header
         transitions and fractional scroll positions from flipping the state. */
      var anchorTop = (anchor || mobileToolbar).getBoundingClientRect().top;
      var isStuck = wasStuck ? anchorTop <= offset + 12 : anchorTop <= offset + 1;
      if (isStuck && !wasStuck) {
        var expandedRect = mobileToolbar.getBoundingClientRect();
        var expandedStyles = window.getComputedStyle(mobileToolbar);
        var expandedMarginBottom = parseFloat(expandedStyles.marginBottom) || 0;
        if (anchor) {
          anchor.style.height = Math.ceil(expandedRect.height + expandedMarginBottom) + 'px';
          anchor.classList.add('is-reserving-space');
        }
        mobileToolbar.style.setProperty('--merlons-toolbar-fixed-left', Math.max(8, Math.round(expandedRect.left)) + 'px');
        mobileToolbar.style.setProperty('--merlons-toolbar-fixed-right', Math.max(8, Math.round(window.innerWidth - expandedRect.right)) + 'px');
        var sorter = mobileToolbar.querySelector('[data-sortby-filter]');
        if (sorter) closeSortDropdown(sorter, false);

        var activeElement = document.activeElement;
        var hiddenControl = activeElement && activeElement.closest && activeElement.closest(
          '.merlons-collection-search, .merlons-collection-sorter'
        );
        if (hiddenControl && mobileToolbar.contains(hiddenControl)) {
          var filterTrigger = mobileToolbar.querySelector('[data-merlons-filter-trigger]');
          if (filterTrigger) filterTrigger.focus({ preventScroll: true });
        }
      } else if (!isStuck && wasStuck) {
        if (anchor) {
          anchor.classList.remove('is-reserving-space');
          anchor.style.removeProperty('height');
        }
        mobileToolbar.style.removeProperty('--merlons-toolbar-fixed-left');
        mobileToolbar.style.removeProperty('--merlons-toolbar-fixed-right');
      }
      mobileToolbar.classList.toggle('is-mobile-stuck', isStuck);
    }
  }

  function queueStickyOffsetSync() {
    if (stickyOffsetFrame) return;
    stickyOffsetFrame = window.requestAnimationFrame(syncStickyOffset);
  }

  function lockPageScroll() {
    var body = document.body;
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    var styles = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight
    };
    body.classList.add('merlons-filter-sheet-open');
    body.style.position = 'fixed';
    body.style.top = '-' + scrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (scrollbarWidth) {
      var existingPadding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = existingPadding + scrollbarWidth + 'px';
    }
    return { scrollY: scrollY, styles: styles };
  }

  function unlockPageScroll(lockState) {
    if (!lockState) return;
    var body = document.body;
    Object.keys(lockState.styles).forEach(function (property) {
      body.style[property] = lockState.styles[property];
    });
    body.classList.remove('merlons-filter-sheet-open');
    window.scrollTo(0, lockState.scrollY);
  }

  function openFilterSheet(trigger) {
    var root = getRoot();
    var sheet = root && root.querySelector('[data-merlons-filter-sheet]');
    var backdrop = root && root.querySelector('[data-merlons-filter-backdrop]');
    if (!sheet || !backdrop || sheet.classList.contains('is-open')) return;

    closeCategorySheet({ restoreFocus: false });

    openSheetState = {
      trigger: trigger || document.activeElement,
      lock: lockPageScroll()
    };
    backdrop.hidden = false;
    sheet.inert = false;
    sheet.removeAttribute('inert');
    sheet.setAttribute('aria-hidden', 'false');
    sheet.classList.add('is-open');
    backdrop.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(function () {
      var close = sheet.querySelector('[data-merlons-filter-close]');
      var focusables = getFocusableElements(sheet);
      (close || focusables[0] || sheet).focus({ preventScroll: true });
    });
  }

  function closeFilterSheet(options) {
    var root = getRoot();
    var sheet = root && root.querySelector('[data-merlons-filter-sheet]');
    var backdrop = root && root.querySelector('[data-merlons-filter-backdrop]');
    if (!sheet || !sheet.classList.contains('is-open')) return;
    var state = openSheetState;
    var restoreFocus = !options || options.restoreFocus !== false;

    sheet.classList.remove('is-open');
    sheet.inert = true;
    sheet.setAttribute('inert', '');
    sheet.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    root.querySelectorAll('[data-merlons-filter-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    unlockPageScroll(state && state.lock);
    openSheetState = null;

    window.setTimeout(function () {
      if (backdrop && !backdrop.classList.contains('is-open')) backdrop.hidden = true;
    }, 270);
    if (restoreFocus && state && state.trigger && document.contains(state.trigger)) {
      state.trigger.focus({ preventScroll: true });
    }
  }

  function openCategorySheet(trigger) {
    var root = getRoot();
    var sheet = root && root.querySelector('[data-merlons-category-sheet]');
    var backdrop = root && root.querySelector('[data-merlons-category-backdrop]');
    if (
      !sheet ||
      !backdrop ||
      sheet.classList.contains('is-open') ||
      document.documentElement.classList.contains('merlons-special-collection')
    ) return;

    closeFilterSheet({ restoreFocus: false });
    openCategorySheetState = {
      trigger: trigger || document.activeElement,
      lock: lockPageScroll()
    };
    backdrop.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    sheet.classList.add('is-open');
    backdrop.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(function () {
      var close = sheet.querySelector('[data-merlons-category-close]');
      var focusables = getFocusableElements(sheet);
      (close || focusables[0] || sheet).focus({ preventScroll: true });
    });
  }

  function closeCategorySheet(options) {
    var root = getRoot();
    var sheet = root && root.querySelector('[data-merlons-category-sheet]');
    var backdrop = root && root.querySelector('[data-merlons-category-backdrop]');
    if (!sheet || !sheet.classList.contains('is-open')) return;
    var state = openCategorySheetState;
    var restoreFocus = !options || options.restoreFocus !== false;

    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    root.querySelectorAll('[data-merlons-category-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    unlockPageScroll(state && state.lock);
    openCategorySheetState = null;

    window.setTimeout(function () {
      if (backdrop && !backdrop.classList.contains('is-open')) backdrop.hidden = true;
    }, 270);
    if (restoreFocus && state && state.trigger && document.contains(state.trigger)) {
      state.trigger.focus({ preventScroll: true });
    }
  }

  function closeSortDropdown(sorter, restoreFocus) {
    if (!sorter) return;
    var trigger = sorter.querySelector('.merlons-collection-sorter__trigger');
    var options = sorter.querySelector('.merlons-collection-sorter__options');
    sorter.classList.remove('act');
    if (trigger) {
      trigger.classList.remove('act');
      trigger.setAttribute('aria-expanded', 'false');
    }
    if (options) {
      if (window.jQuery) window.jQuery(options).stop(true, true).slideUp(150);
      else options.style.display = 'none';
    }
    if (restoreFocus && trigger) trigger.focus({ preventScroll: true });
  }

  function syncSortAccessibility() {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-sortby-filter]').forEach(function (sorter) {
      var trigger = sorter.querySelector('.merlons-collection-sorter__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', trigger.classList.contains('act') ? 'true' : 'false');
      sorter.querySelectorAll('[data-sortby-item]').forEach(function (item) {
        item.setAttribute('aria-checked', item.classList.contains('act') ? 'true' : 'false');
      });
    });
  }

  function collectionDataPath() {
    var grid = document.getElementById('product-grid');
    return (grid && grid.getAttribute('data-filter-path')) || window.location.pathname;
  }

  function collectionDataParams(pageNumber, viewName) {
    var params = getSearchParams();
    params.delete('q');
    params.delete('options[prefix]');
    params.delete('merlons_sort');
    params.delete('merlons_offer');
    params.delete('page');
    params.delete('section_id');
    params.delete('view');
    params.set('view', viewName || 'merlons-query-data');
    params.set('page', String(pageNumber));
    return params;
  }

  function collectionCacheKey(viewName) {
    var params = collectionDataParams(1, viewName);
    params.delete('page');
    params.sort();
    return collectionDataPath() + '?' + params.toString();
  }

  function itemRecord(element, includeMarkup) {
    var price = Number(element.getAttribute('data-merlons-price') || 0);
    var compareAtPrice = Number(element.getAttribute('data-merlons-compare-at-price') || 0);
    var collectionHandlesAttribute = element.getAttribute('data-merlons-collection-handles');
    var discountRatio = compareAtPrice > price && compareAtPrice > 0
      ? (compareAtPrice - price) / compareAtPrice
      : 0;
    var fallbackDiscount = discountRatio > 0 && discountRatio <= 0.44;
    var fallbackLiquidation = discountRatio > 0.44;
    return {
      id: element.getAttribute('data-product-id') || '',
      markup: includeMarkup ? element.outerHTML : '',
      collectionHandlesKnown: collectionHandlesAttribute !== null,
      collectionHandles: String(collectionHandlesAttribute || '').split('|').filter(Boolean),
      discountRatio: discountRatio,
      isDiscounted: elementBooleanAttribute(element, 'data-merlons-offer-discount', fallbackDiscount),
      isLiquidation: elementBooleanAttribute(element, 'data-merlons-offer-liquidation', fallbackLiquidation)
    };
  }

  function fetchDocument(url, signal) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      return response.text();
    }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function runPageWorkers(totalPages, firstPageItems, fetchPage) {
    var pageItems = new Array(totalPages);
    pageItems[0] = firstPageItems;
    var nextPage = 2;
    var workerCount = Math.min(4, Math.max(0, totalPages - 1));
    var workers = [];

    function worker() {
      var page = nextPage++;
      if (page > totalPages) return Promise.resolve();
      return fetchPage(page).then(function (items) {
        pageItems[page - 1] = items;
        return worker();
      });
    }

    for (var index = 0; index < workerCount; index += 1) workers.push(worker());
    return Promise.all(workers).then(function () {
      return pageItems.reduce(function (all, items) {
        return all.concat(items || []);
      }, []);
    });
  }

  function fetchAllCollectionItems(signal) {
    var key = collectionCacheKey();
    if (collectionItemsCache.has(key)) return Promise.resolve(collectionItemsCache.get(key));

    function fetchPage(pageNumber) {
      var url = new URL(collectionDataPath(), window.location.origin);
      var params = collectionDataParams(pageNumber);
      url.search = params.toString();
      return fetchDocument(url.pathname + url.search, signal).then(function (documentNode) {
        var grid = documentNode.getElementById('product-grid');
        if (!grid) throw new Error('Collection query grid is missing');
        return {
          totalPages: Math.min(1000, Math.max(1, Number(grid.getAttribute('data-total-pages') || 1))),
          items: Array.prototype.map.call(grid.querySelectorAll('.merlons-query-product'), function (item) {
            return itemRecord(item, false);
          })
        };
      });
    }

    return fetchPage(1).then(function (firstPage) {
      return runPageWorkers(firstPage.totalPages, firstPage.items, function (pageNumber) {
        return fetchPage(pageNumber).then(function (page) { return page.items; });
      });
    }).then(function (items) {
      var seen = new Set();
      var uniqueItems = items.filter(function (item) {
        var keyValue = item.id || item.markup;
        if (seen.has(keyValue)) return false;
        seen.add(keyValue);
        return true;
      });
      setBoundedCache(collectionItemsCache, key, uniqueItems, 4);
      return uniqueItems;
    });
  }

  function searchRequestPath(query, pageNumber, viewName) {
    var root = getRoot();
    var searchPath = (root && root.getAttribute('data-merlons-search-path')) || '/search';
    var cardViewtype = root && root.getAttribute('data-merlons-card-viewtype');
    var url = new URL(searchPath, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    getSearchParams().forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) url.searchParams.append(key, value);
    });
    url.searchParams.set('view', viewName || (cardViewtype === 'flash_deal' ? 'merlons-query-cards-flash' : 'merlons-query-cards'));
    url.searchParams.set('page', String(pageNumber));
    return url.pathname + url.search;
  }

  function searchCacheKey(query, viewName) {
    var url = new URL(searchRequestPath(query, 1, viewName), window.location.origin);
    url.searchParams.delete('page');
    url.searchParams.sort();
    return url.pathname + '?' + url.searchParams.toString();
  }

  function fetchSearchProductItems(query, signal) {
    var root = getRoot();
    var cardViewtype = root && root.getAttribute('data-merlons-card-viewtype');
    var viewName = cardViewtype === 'flash_deal' ? 'merlons-query-cards-flash' : 'merlons-query-cards';
    var key = searchCacheKey(query, viewName);
    if (searchItemsCache.has(key)) return Promise.resolve(searchItemsCache.get(key));

    function fetchPage(pageNumber) {
      return fetchDocument(searchRequestPath(query, pageNumber, viewName), signal).then(function (documentNode) {
        var container = documentNode.getElementById('MerlonsSearchProductCards');
        if (!container) throw new Error('Search result index is missing');
        return {
          totalPages: Math.min(1000, Math.max(1, Number(container.getAttribute('data-total-pages') || 1))),
          items: Array.prototype.map.call(container.querySelectorAll('.product--item[data-product-id]'), function (item) {
            return itemRecord(item, true);
          })
        };
      });
    }

    return fetchPage(1).then(function (firstPage) {
      return runPageWorkers(firstPage.totalPages, firstPage.items, function (pageNumber) {
        return fetchPage(pageNumber).then(function (page) { return page.items; });
      });
    }).then(function (items) {
      var uniqueItems = new Map();
      items.forEach(function (item) {
        if (item.id && !uniqueItems.has(item.id)) uniqueItems.set(item.id, item);
      });
      setBoundedCache(searchItemsCache, key, uniqueItems, 4);
      return uniqueItems;
    });
  }

  function captureQueryPaginationLabels() {
    var source = document.querySelector('#main-collection-filters [data-merlons-infinite-scroll]');
    if (source) {
      var fallback = source.querySelector('.merlons-infinite-scroll__fallback');
      queryPaginationLabels = {
        loading: source.getAttribute('data-loading-label') || '',
        loaded: source.getAttribute('data-loaded-label') || '',
        complete: source.getAttribute('data-complete-label') || '',
        error: source.getAttribute('data-error-label') || '',
        button: fallback ? normalizeQuery(fallback.textContent) : ''
      };
    }
    if (queryPaginationLabels) return queryPaginationLabels;
    return {
      loading: getStatusLabel('data-merlons-search-loading-label'),
      loaded: '',
      complete: '',
      error: getStatusLabel('data-merlons-search-error-label'),
      button: ''
    };
  }

  function cancelQueryInfiniteScroll(removeSentinel) {
    if (!queryInfiniteState) return;
    if (queryInfiniteState.observer) queryInfiniteState.observer.disconnect();
    if (removeSentinel !== false && queryInfiniteState.sentinel && queryInfiniteState.sentinel.parentNode) {
      queryInfiniteState.sentinel.remove();
    }
    queryInfiniteState = null;
  }

  function getQueryBatchSize() {
    return window.matchMedia('(max-width: 767px)').matches ? 12 : 24;
  }

  function updateResultCounts(displayedCount, totalCount) {
    var displayed = Math.max(0, Number(displayedCount) || 0);
    var total = Math.max(displayed, Number(totalCount) || 0);
    document.querySelectorAll('#main-collection-filters .pagination__count').forEach(function (counter) {
      var countNode = counter.querySelector('.count');
      var totalNode = counter.querySelector('.total');
      if (countNode) countNode.textContent = String(displayed);
      if (totalNode) totalNode.textContent = String(total);
    });
    document.querySelectorAll('#main-collection-filters .pagination__bar').forEach(function (bar) {
      bar.setAttribute('data-max', String(total));
      var progress = bar.querySelector('.progress');
      if (progress) progress.style.width = total ? Math.min(100, (displayed / total) * 100) + '%' : '0%';
    });
  }

  function categoryHierarchyStateKey() {
    var url = new URL(window.location.href);
    ['page', 'section_id', 'view'].forEach(function (key) { url.searchParams.delete(key); });
    url.hash = '';
    url.searchParams.sort();
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
  }

  function categoryHierarchyRequestPath(source, pageNumber) {
    var url = new URL(source.url, window.location.origin);
    var params = getSearchParams();
    params.delete('q');
    params.delete('options[prefix]');
    params.delete('merlons_sort');
    params.delete('merlons_offer');
    params.delete('page');
    params.delete('section_id');
    params.delete('view');
    params.set('view', 'merlons-hierarchy-cards');
    params.set('page', String(pageNumber));
    url.search = params.toString();
    return url.pathname + url.search;
  }

  function categoryHierarchyLabels() {
    var root = getRoot();
    return {
      button: root ? root.getAttribute('data-merlons-load-more-label') || '' : '',
      loading: root ? root.getAttribute('data-merlons-load-loading-label') || '' : '',
      loaded: root ? root.getAttribute('data-merlons-load-loaded-label') || '' : '',
      complete: root ? root.getAttribute('data-merlons-load-complete-label') || '' : '',
      error: root ? root.getAttribute('data-merlons-load-error-label') || '' : ''
    };
  }

  function parseCategoryHierarchyFacetData(documentNode) {
    var source = documentNode && documentNode.querySelector('[data-merlons-hierarchy-facet-data]');
    if (!source) return null;
    try {
      var data = JSON.parse(source.textContent || '{}');
      return data && Array.isArray(data.filters) ? data : null;
    } catch (error) {
      console.error('[Merlons category hierarchy facets]', error);
      return null;
    }
  }

  function canonicalCategoryHierarchyFacetData() {
    var root = getRoot();
    var source = root && root.querySelector('[data-merlons-canonical-hierarchy-facet-data]');
    if (!source) return null;
    try {
      var data = JSON.parse(source.textContent || '{}');
      return data && Array.isArray(data.filters) ? data : null;
    } catch (error) {
      console.error('[Merlons canonical hierarchy facets]', error);
      return null;
    }
  }

  function hasNativeCollectionFacets(root) {
    return Boolean(root && root.querySelector('.js-filter:not([data-merlons-offer-filter]):not([data-merlons-hierarchy-facet])'));
  }

  function removeCategoryHierarchyFacets() {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-merlons-hierarchy-facet]').forEach(function (facet) { facet.remove(); });
    root.querySelectorAll('[data-merlons-hierarchy-active-facet]').forEach(function (facet) { facet.remove(); });
  }

  function categoryHierarchyFacetKind(label) {
    var normalized = normalizeQuery(label).toLocaleLowerCase();
    if (['color', 'colour', 'filter color', 'ფერი', 'ფერის მიხედვით', 'цвет', 'по цвету'].indexOf(normalized) !== -1) return 'color';
    if (['size', 'filter size', 'ზომა', 'ზომის მიხედვით', 'размер'].indexOf(normalized) !== -1) return 'size';
    if (['mounting_type', 'mounting type', 'filter mounting type', 'merlons filter mounting type', 'merlons filter mounting type selector', 'merlons_catalog.filter_mounting_type', 'merlons_catalog.filter_mounting_type_reference', 'ტიპი', 'სამაგრის ტიპი', 'მონტაჟის ტიპი', 'тип монтажа'].indexOf(normalized) !== -1) return 'mounting';
    return '';
  }

  function appendCategoryHierarchyChevron(title) {
    var root = getRoot();
    if (!root || (!root.classList.contains('merlons-toolbar-enabled') && !root.classList.contains('page-search'))) return;
    var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    chevron.setAttribute('class', 'facets__label-chevron');
    chevron.setAttribute('viewBox', '0 0 20 20');
    chevron.setAttribute('aria-hidden', 'true');
    chevron.setAttribute('focusable', 'false');
    path.setAttribute('d', 'm5.5 7.5 4.5 4.5 4.5-4.5');
    chevron.appendChild(path);
    title.appendChild(chevron);
  }

  function categoryHierarchyFacetClearLabel() {
    var root = getRoot();
    if (!root) return '';
    var configuredLabel = normalizeQuery(root.getAttribute('data-merlons-filter-clear-label'));
    if (configuredLabel) return configuredLabel;
    var nativeReset = root.querySelector('.facets__reset');
    return nativeReset ? normalizeQuery(nativeReset.textContent) : '';
  }

  function categoryHierarchyFacetSelectedLabel(count) {
    var root = getRoot();
    if (!root) return '';
    var template = root.getAttribute('data-merlons-filters-selected-template') || '';
    if (template.indexOf('__COUNT__') !== -1) return template.replace(/__COUNT__/g, String(count));
    var nativeSelected = root.querySelector('.facets__selected');
    if (!nativeSelected) return '';
    var text = normalizeQuery(nativeSelected.textContent);
    var match = text.match(/\d+/);
    if (!match) return '';
    return text.slice(0, match.index) + String(count) + text.slice(match.index + match[0].length);
  }

  function categoryHierarchyFacetResetHref(params, filter) {
    var next = new URLSearchParams(params);
    filter.values.forEach(function (value) { next.delete(value.paramName); });
    next.delete('page');
    var query = next.toString();
    return window.location.pathname + (query ? '?' + query : '');
  }

  function appendCategoryHierarchyFacetReset(heading, filter, params, isPrice) {
    var clearLabel = categoryHierarchyFacetClearLabel();
    if (!clearLabel) return;
    var reset = document.createElement('facet-remove');
    var link = document.createElement('a');
    link.className = 'facets__reset' + (isPrice ? ' reset_price' : '');
    link.href = isPrice
      ? categoryHierarchyFacetRemovalHref(params, filter.minParamName, null, filter.maxParamName)
      : categoryHierarchyFacetResetHref(params, filter);
    link.textContent = clearLabel;
    reset.appendChild(link);
    heading.appendChild(reset);
  }

  function appendCategoryHierarchyPriceTicks(bar, rangeMax) {
    [
      { value: '0', className: 'progress-number position-absolute' },
      { value: String(Math.floor(25 * rangeMax / 100)), className: 'progress-number position-absolute inner', left: '25%' },
      { value: String(Math.floor(50 * rangeMax / 100)), className: 'progress-number position-absolute inner', left: '50%' },
      { value: String(Math.floor(75 * rangeMax / 100)), className: 'progress-number position-absolute inner', left: '75%' },
      { value: String(rangeMax), className: 'progress-number position-absolute', right: '0' }
    ].forEach(function (tickData) {
      var tick = document.createElement('div');
      tick.className = tickData.className;
      if (tickData.left) tick.style.left = tickData.left;
      if (tickData.right) tick.style.right = tickData.right;
      tick.textContent = tickData.value;
      bar.appendChild(tick);
    });
  }

  function appendCategoryHierarchyCheckbox(parent, filter, value, index, params) {
    var selected = params.getAll(value.paramName).indexOf(value.value) !== -1;
    var disabled = value.count === 0 && !selected;
    var kind = categoryHierarchyFacetKind(filter.rawLabel || filter.label);
    var inputId = 'MerlonsHierarchyFacet-' + index + '-' + value.index;
    var item = document.createElement('li');
    var label = document.createElement('label');
    var input = document.createElement('input');
    var checkbox = document.createElement('span');
    var checkmark = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var checkmarkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    var valueLabel = document.createElement('span');
    var count = document.createElement('span');

    item.className = 'list-menu__item facets__item' + (kind === 'color' ? ' facet-color-text' : '') + (kind === 'size' ? ' facet-size' : '') + (disabled ? ' is-disabled' : '');
    label.className = 'facet-checkbox pointer d-flex align-items-center' + (disabled ? ' facet-checkbox--disabled' : '');
    label.htmlFor = inputId;
    label.title = value.label;
    input.type = 'checkbox';
    input.name = value.paramName;
    input.value = value.value;
    input.id = inputId;
    input.checked = selected;
    input.setAttribute('aria-label', filter.label + ': ' + value.label + (value.count == null ? '' : ' (' + value.count + ')'));
    if (disabled) {
      input.disabled = true;
      input.setAttribute('aria-disabled', 'true');
    }
    checkbox.className = 'custom-checkbox';
    checkbox.setAttribute('aria-hidden', 'true');
    checkmark.setAttribute('class', 'merlons-icon merlons-icon--check');
    checkmark.setAttribute('aria-hidden', 'true');
    checkmark.setAttribute('focusable', 'false');
    checkmark.setAttribute('viewBox', '0 0 24 24');
    checkmark.setAttribute('width', '16');
    checkmark.setAttribute('height', '16');
    checkmark.setAttribute('fill', 'none');
    checkmarkPath.setAttribute('d', 'm5 12 4 4L19 6');
    checkmarkPath.setAttribute('stroke', 'currentColor');
    checkmarkPath.setAttribute('stroke-width', '2');
    checkmarkPath.setAttribute('stroke-linecap', 'round');
    checkmarkPath.setAttribute('stroke-linejoin', 'round');
    checkmark.appendChild(checkmarkPath);
    checkbox.appendChild(checkmark);
    valueLabel.className = 'filter-option-value';
    valueLabel.textContent = value.label;
    count.className = 'value_count';
    count.setAttribute('aria-hidden', 'true');
    if (value.count == null) count.hidden = true;
    else count.textContent = '(' + value.count + ')';
    label.appendChild(input);
    label.appendChild(checkbox);
    label.appendChild(valueLabel);
    label.appendChild(count);
    item.appendChild(label);
    parent.appendChild(item);
  }

  function createCategoryHierarchyListFacet(filter, index, params) {
    var kind = categoryHierarchyFacetKind(filter.rawLabel || filter.label);
    var facetId = 'MerlonsHierarchyFacetContent-' + index;
    var selectedCount = filter.values.filter(function (value) {
      return params.getAll(value.paramName).indexOf(value.value) !== -1;
    }).length;
    var facet = document.createElement('div');
    var heading = document.createElement('div');
    var title = document.createElement('button');
    var titleText = document.createElement('span');
    var selected = document.createElement('span');
    var content = document.createElement('div');
    var fieldset = document.createElement('fieldset');
    var legend = document.createElement('legend');
    var list = document.createElement('ul');

    facet.className = 'js-filter';
    facet.setAttribute('data-merlons-hierarchy-facet', '');
    facet.setAttribute('data-index', 'merlons-hierarchy-' + index);
    if (kind) facet.setAttribute('data-filter-kind', kind);
    heading.className = 'facets__label position-relative';
    title.type = 'button';
    title.className = 'facets__label--title';
    title.setAttribute('aria-expanded', 'false');
    title.setAttribute('aria-controls', facetId);
    titleText.textContent = filter.label;
    selected.className = 'facets__selected merlons-visually-hidden';
    selected.setAttribute('aria-live', 'polite');
    selected.textContent = categoryHierarchyFacetSelectedLabel(selectedCount);
    content.className = 'facets__content';
    content.id = facetId;
    fieldset.className = 'facets__fieldset';
    legend.className = 'merlons-visually-hidden';
    legend.textContent = filter.label;
    list.className = 'facets__list list-unstyled' + (kind === 'color' ? ' facets__list-color' : '') + (kind === 'size' ? ' facets__list-size' : '');
    list.setAttribute('role', 'list');
    filter.values.forEach(function (value) { appendCategoryHierarchyCheckbox(list, filter, value, index, params); });
    title.appendChild(titleText);
    appendCategoryHierarchyChevron(title);
    heading.appendChild(title);
    appendCategoryHierarchyFacetReset(heading, filter, params, false);
    fieldset.appendChild(legend);
    fieldset.appendChild(list);
    content.appendChild(fieldset);
    facet.appendChild(heading);
    facet.appendChild(selected);
    facet.appendChild(content);
    return facet;
  }

  function createCategoryHierarchyPriceFacet(filter, index, params) {
    var rangeMax = Math.max(1, Math.ceil(filter.rangeMax / 100));
    var facetId = 'MerlonsHierarchyFacetContent-' + index;
    var minValue = params.get(filter.minParamName) || '';
    var maxValue = params.get(filter.maxParamName) || '';
    var facet = document.createElement('div');
    var heading = document.createElement('div');
    var title = document.createElement('button');
    var titleText = document.createElement('span');
    var content = document.createElement('div');
    var display = document.createElement('div');
    var priceRange = document.createElement('div');
    var range = document.createElement('div');
    var minRange = document.createElement('input');
    var maxRange = document.createElement('input');
    var bar = document.createElement('div');
    var barBackground = document.createElement('div');
    var progress = document.createElement('div');
    var minSubmit = document.createElement('input');
    var maxSubmit = document.createElement('input');
    var inputs = document.createElement('div');
    var minInput = document.createElement('input');
    var separator = document.createElement('span');
    var maxInput = document.createElement('input');

    facet.className = 'js-filter js-filter-price';
    facet.setAttribute('data-merlons-hierarchy-facet', '');
    facet.setAttribute('data-index', 'merlons-hierarchy-' + index);
    heading.className = 'facets__label position-relative';
    title.type = 'button';
    title.className = 'facets__label--title';
    title.setAttribute('aria-expanded', 'false');
    title.setAttribute('aria-controls', facetId);
    titleText.textContent = filter.label;
    content.className = 'facets__content';
    content.id = facetId;
    display.className = 'facets__display';
    priceRange.className = 'facets__price';
    range.className = 'filter__price--range position-relative';
    minRange.type = 'range';
    minRange.className = 'field__range--min';
    minRange.min = '0';
    minRange.max = String(rangeMax);
    minRange.step = '1';
    minRange.value = minValue || '0';
    minRange.setAttribute('aria-label', filter.label + ': 0');
    maxRange.type = 'range';
    maxRange.className = 'field__range--max';
    maxRange.min = '0';
    maxRange.max = String(rangeMax);
    maxRange.step = '1';
    maxRange.value = maxValue || String(rangeMax);
    maxRange.setAttribute('aria-label', filter.label + ': ' + rangeMax);
    bar.className = 'filter__price--bar position-relative';
    barBackground.className = 'filter__price--bar__bg';
    progress.className = 'progress';
    minSubmit.type = 'hidden';
    minSubmit.name = filter.minParamName;
    minSubmit.value = minValue;
    minSubmit.setAttribute('data-merlons-price-submit', 'min');
    maxSubmit.type = 'hidden';
    maxSubmit.name = filter.maxParamName;
    maxSubmit.value = maxValue;
    maxSubmit.setAttribute('data-merlons-price-submit', 'max');
    inputs.className = 'filter__price--input d-flex align-items-center position-relative';
    minInput.className = 'field__input field__input--min';
    minInput.type = 'number';
    minInput.placeholder = '0';
    minInput.min = '0';
    minInput.max = maxValue || String(rangeMax);
    minInput.value = minValue;
    minInput.setAttribute('aria-label', filter.label + ': 0');
    separator.className = 'field__text';
    separator.textContent = '—';
    maxInput.className = 'field__input field__input--max';
    maxInput.type = 'number';
    maxInput.placeholder = String(rangeMax);
    maxInput.min = minValue || '0';
    maxInput.max = String(rangeMax);
    maxInput.value = maxValue;
    maxInput.setAttribute('aria-label', filter.label + ': ' + rangeMax);
    title.appendChild(titleText);
    appendCategoryHierarchyChevron(title);
    heading.appendChild(title);
    appendCategoryHierarchyFacetReset(heading, filter, params, true);
    range.appendChild(minRange);
    range.appendChild(maxRange);
    bar.appendChild(barBackground);
    bar.appendChild(progress);
    appendCategoryHierarchyPriceTicks(bar, rangeMax);
    inputs.appendChild(minInput);
    inputs.appendChild(separator);
    inputs.appendChild(maxInput);
    priceRange.appendChild(range);
    priceRange.appendChild(bar);
    priceRange.appendChild(minSubmit);
    priceRange.appendChild(maxSubmit);
    priceRange.appendChild(inputs);
    display.appendChild(priceRange);
    content.appendChild(display);
    facet.appendChild(heading);
    facet.appendChild(content);
    function clampPrice(value, fallback, preserveDecimals) {
      var parsed = Number(value);
      if (!Number.isFinite(parsed)) return fallback;
      var clamped = Math.min(rangeMax, Math.max(0, parsed));
      return preserveDecimals ? clamped : Math.round(clamped);
    }
    function updatePriceProgress() {
      var min = clampPrice(minRange.value, 0, true);
      var max = Math.max(min, clampPrice(maxRange.value, rangeMax, true));
      progress.style.left = (min / rangeMax) * 100 + '%';
      progress.style.right = 100 - (max / rangeMax) * 100 + '%';
    }
    function syncPriceInputsFromRanges() {
      var min = clampPrice(minRange.value, 0);
      var max = Math.max(min, clampPrice(maxRange.value, rangeMax));
      minRange.value = String(min);
      maxRange.value = String(max);
      minInput.value = min === 0 ? '' : String(min);
      maxInput.value = max === rangeMax ? '' : String(max);
      minSubmit.value = minInput.value;
      maxSubmit.value = maxInput.value;
      updatePriceProgress();
    }
    function syncPriceRangesFromInputs() {
      var min = clampPrice(minInput.value, 0, true);
      var max = clampPrice(maxInput.value, rangeMax, true);
      if (min > max) max = min;
      minRange.value = String(min);
      maxRange.value = String(max);
      if (minInput.value) minInput.value = String(min);
      if (maxInput.value) maxInput.value = String(max);
      minSubmit.value = minInput.value;
      maxSubmit.value = maxInput.value;
      updatePriceProgress();
    }
    minRange.addEventListener('input', syncPriceInputsFromRanges);
    maxRange.addEventListener('input', syncPriceInputsFromRanges);
    minInput.addEventListener('input', syncPriceRangesFromInputs);
    maxInput.addEventListener('input', syncPriceRangesFromInputs);
    syncPriceRangesFromInputs();
    return facet;
  }

  function categoryHierarchyFacetRemovalHref(params, paramName, value, additionalParamName) {
    var next = new URLSearchParams(params);
    [paramName, additionalParamName].filter(Boolean).forEach(function (name) { next.delete(name); });
    if (value != null) {
      params.getAll(paramName).filter(function (current) { return current !== value; }).forEach(function (current) {
        next.append(paramName, current);
      });
    }
    next.delete('page');
    var query = next.toString();
    return window.location.pathname + (query ? '?' + query : '');
  }

  function appendCategoryHierarchyActiveFacet(container, label, value, href) {
    var chip = document.createElement('facet-remove');
    var link = document.createElement('a');
    var text = document.createElement('span');
    var labelText = document.createElement('span');
    var valueText = document.createElement('strong');
    var close = document.createElement('span');
    chip.className = 'btn--clear--item';
    chip.setAttribute('data-merlons-hierarchy-active-facet', '');
    link.className = 'active-facets__button position-relative d-flex align-items-center';
    link.href = href;
    labelText.className = 'filter__label';
    labelText.textContent = label + ': ';
    valueText.textContent = value;
    close.setAttribute('aria-hidden', 'true');
    close.textContent = '×';
    text.appendChild(labelText);
    text.appendChild(valueText);
    link.appendChild(text);
    link.appendChild(close);
    chip.appendChild(link);
    container.appendChild(chip);
  }

  function renderCategoryHierarchyActiveFacets(filters, params) {
    var root = getRoot();
    var container = root && root.querySelector('[data-merlons-active-facet-items]');
    var results = root && root.querySelector('[data-merlons-active-facets-results]');
    if (!container) return;
    container.querySelectorAll('[data-merlons-hierarchy-active-facet]').forEach(function (facet) { facet.remove(); });
    var count = 0;
    filters.forEach(function (filter) {
      if (filter.type === 'price_range') {
        var min = params.get(filter.minParamName);
        var max = params.get(filter.maxParamName);
        if (min == null && max == null) return;
        appendCategoryHierarchyActiveFacet(
          container,
          filter.label,
          (min || '0') + '—' + (max || String(Math.ceil(filter.rangeMax / 100))),
          categoryHierarchyFacetRemovalHref(params, filter.minParamName, null, filter.maxParamName)
        );
        count += 1;
        return;
      }
      filter.values.forEach(function (value) {
        if (params.getAll(value.paramName).indexOf(value.value) === -1) return;
        appendCategoryHierarchyActiveFacet(
          container,
          filter.label,
          value.label,
          categoryHierarchyFacetRemovalHref(params, value.paramName, value.value)
        );
        count += 1;
      });
    });
    if (results && count) results.hidden = false;
  }

  function renderCategoryHierarchyFacets(state) {
    var root = getRoot();
    var form = root && root.querySelector('#CollectionFiltersForm');
    var wrapper = form && form.querySelector('.CollecttionFilterWrapper');
    if (!root || !wrapper || !hasCategoryDescendants() || hasNativeCollectionFacets(root)) return;
    removeCategoryHierarchyFacets();

    var filters = new Map();
    state.facetSources.forEach(function (data) {
      data.filters.forEach(function (filter) {
        if (!filter || !filter.label) return;
        if (filter.type === 'price_range') {
          if (!filter.minParamName || !filter.maxParamName || !Number(filter.rangeMax)) return;
          var priceKey = 'price\u0000' + filter.minParamName + '\u0000' + filter.maxParamName;
          var priceFilter = filters.get(priceKey);
          if (!priceFilter) {
            priceFilter = { type: 'price_range', label: filter.label, rawLabel: filter.rawLabel || filter.label, minParamName: filter.minParamName, maxParamName: filter.maxParamName, rangeMax: 0 };
            filters.set(priceKey, priceFilter);
          }
          priceFilter.rangeMax = Math.max(priceFilter.rangeMax, Number(filter.rangeMax) || 0);
          return;
        }
        if ((filter.type !== 'list' && filter.type !== 'boolean') || !Array.isArray(filter.values)) return;
        var filterKey = filter.type + '\u0000' + filter.label;
        var aggregate = filters.get(filterKey);
        if (!aggregate) {
          aggregate = { type: filter.type, label: filter.label, rawLabel: filter.rawLabel || filter.label, values: new Map() };
          filters.set(filterKey, aggregate);
        }
        filter.values.forEach(function (value) {
          if (!value || !value.paramName || value.value == null) return;
          var valueKey = value.paramName + '\u0000' + String(value.value);
          var current = aggregate.values.get(valueKey);
          if (!current) {
            current = { paramName: String(value.paramName), value: String(value.value), label: String(value.label || value.value), count: 0, index: aggregate.values.size + 1 };
            aggregate.values.set(valueKey, current);
          }
          current.count += Math.max(0, Number(value.count) || 0);
        });
      });
    });

    var canonical = state.canonicalFacetData;
    var canonicalProductCount = canonical && Number(canonical.productCount);
    var canonicalCoversResult = canonical && canonicalProductCount > 0 && !(
      state.hierarchyComplete && state.knownIds.size > canonicalProductCount
    );
    if (canonicalCoversResult) {
      var canonicalValues = new Map();
      canonical.filters.forEach(function (filter) {
        if (!filter || !Array.isArray(filter.values)) return;
        filter.values.forEach(function (value) {
          if (!value || !value.paramName || value.value == null) return;
          canonicalValues.set(
            filter.type + '\u0000' + filter.label + '\u0000' + value.paramName + '\u0000' + String(value.value),
            Math.max(0, Number(value.count) || 0)
          );
        });
      });
      filters.forEach(function (filter) {
        if (!filter.values) return;
        filter.values.forEach(function (value) {
          var key = filter.type + '\u0000' + filter.label + '\u0000' + value.paramName + '\u0000' + String(value.value);
          value.count = canonicalValues.has(key) ? canonicalValues.get(key) : null;
        });
      });
    } else {
      // Source-level counts cannot be made value-accurate without product
      // facet membership (the same product may occur in multiple sources).
      // Keep filtering enabled, but hide unknown counts instead of displaying
      // a potentially inflated number.
      filters.forEach(function (filter) {
        if (!filter.values) return;
        filter.values.forEach(function (value) { value.count = null; });
      });
    }

    var params = getSearchParams();
    var index = 1;
    filters.forEach(function (filter) {
      if (filter.type === 'price_range') {
        wrapper.appendChild(createCategoryHierarchyPriceFacet(filter, index, params));
        index += 1;
        return;
      }
      var filterKind = categoryHierarchyFacetKind(filter.rawLabel || filter.label);
      filter.values = Array.from(filter.values.values()).sort(function (left, right) {
        if (filterKind === 'mounting') {
          var rankDifference = mountingFilterValueRank(left.label) - mountingFilterValueRank(right.label);
          if (rankDifference) return rankDifference;
        }
        return left.label.localeCompare(right.label, document.documentElement.lang || undefined);
      });
      if (!filter.values.length) return;
      wrapper.appendChild(createCategoryHierarchyListFacet(filter, index, params));
      index += 1;
    });
    renderCategoryHierarchyActiveFacets(Array.from(filters.values()), params);
  }

  function registerCategoryHierarchyFacets(state, source, documentNode) {
    if (!state || !source || source.facetsRegistered) return;
    source.facetsRegistered = true;
    var data = parseCategoryHierarchyFacetData(documentNode);
    if (!data) return;
    state.facetSources.set(source.url, data);
    renderCategoryHierarchyFacets(state);
  }

  function sortCategoryHierarchyItems(state) {
    if (!state || !state.grid || !state.sortMode) return;
    var comparators = {
      'price-ascending': function (left, right) { return left.price - right.price; },
      'price-descending': function (left, right) { return right.price - left.price; },
      'title-ascending': function (left, right) { return left.title.localeCompare(right.title, document.documentElement.lang || undefined); },
      'title-descending': function (left, right) { return right.title.localeCompare(left.title, document.documentElement.lang || undefined); },
      'created-ascending': function (left, right) { return left.createdAt - right.createdAt; },
      'created-descending': function (left, right) { return right.createdAt - left.createdAt; }
    };
    var comparator = comparators[state.sortMode];
    if (!comparator) return;
    var records = Array.prototype.map.call(
      state.grid.querySelectorAll('.product--item[data-product-id]'),
      function (item, index) {
        return {
          item: item,
          index: index,
          price: Number(item.getAttribute('data-merlons-price') || 0),
          title: String(item.getAttribute('data-merlons-title') || '').trim(),
          createdAt: Number(item.getAttribute('data-merlons-created-at') || 0)
        };
      }
    );
    records.sort(function (left, right) {
      var result = comparator(left, right);
      return result || left.index - right.index;
    });
    var fragment = document.createDocumentFragment();
    records.forEach(function (record) { fragment.appendChild(record.item); });
    state.grid.appendChild(fragment);
  }

  function cancelCategoryHierarchy(removeSentinel) {
    categoryHierarchyGeneration += 1;
    removeCategoryHierarchyFacets();
    if (!categoryHierarchyState) return;
    if (categoryHierarchyState.observer) categoryHierarchyState.observer.disconnect();
    if (categoryHierarchyState.controller) categoryHierarchyState.controller.abort();
    if (
      removeSentinel !== false &&
      categoryHierarchyState.sentinel &&
      categoryHierarchyState.sentinel.parentNode
    ) {
      categoryHierarchyState.sentinel.remove();
    }
    var root = getRoot();
    var container = document.getElementById('CollectionProductContainer');
    if (root) root.removeAttribute('data-merlons-hierarchy-loading');
    if (container) container.removeAttribute('aria-busy');
    categoryHierarchyState = null;
  }

  window.merlonsCancelCategoryHierarchy = cancelCategoryHierarchy;

  function finishCategoryHierarchy(state) {
    if (!state || state !== categoryHierarchyState) return;
    if (state.observer) state.observer.disconnect();
    state.loading = false;
    state.failed = false;
    state.hierarchyComplete = true;
    state.grid.setAttribute('data-total-products', String(state.knownIds.size));
    state.grid.setAttribute('data-total-pages', String(Math.max(1, state.pagesLoaded)));
    updateResultCounts(state.knownIds.size, state.knownIds.size);
    renderCategoryHierarchyFacets(state);
    state.sentinel.setAttribute('aria-busy', 'false');
    state.sentinel.classList.remove('is-loading', 'is-error');
    state.sentinel.classList.add('is-complete');
    state.button.disabled = true;
    state.button.setAttribute('aria-disabled', 'true');
    state.button.textContent = state.labels.complete || state.labels.loaded || state.labels.button;
    state.status.textContent = state.labels.complete || '';
    var root = getRoot();
    if (root) root.removeAttribute('data-merlons-hierarchy-loading');
    var container = document.getElementById('CollectionProductContainer');
    if (container) container.removeAttribute('aria-busy');
  }

  function categoryHierarchyObserve(state) {
    if (!state || state !== categoryHierarchyState || !state.observer || state.failed) return;
    state.observer.observe(state.sentinel);
  }

  function loadNextCategoryHierarchyPage(state, forceRetry) {
    if (
      !state ||
      state !== categoryHierarchyState ||
      state.loading ||
      !state.grid.isConnected ||
      state.grid !== document.getElementById('product-grid') ||
      state.stateKey !== categoryHierarchyStateKey() ||
      getCurrentQuery()
    ) return;
    if (state.failed && !forceRetry) return;
    if (!state.queue.length) {
      finishCategoryHierarchy(state);
      return;
    }

    state.failed = false;
    if (state.observer) state.observer.disconnect();
    var source = state.queue.shift();
    var requestedPage = source.nextPage;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var requestGeneration = state.generation;
    var root = getRoot();
    var container = document.getElementById('CollectionProductContainer');
    state.controller = controller;
    state.loading = true;
    state.sentinel.setAttribute('aria-busy', 'true');
    state.sentinel.classList.remove('is-error', 'is-complete');
    state.sentinel.classList.add('is-loading');
    state.button.disabled = true;
    state.status.textContent = state.labels.loading || '';
    if (root) root.setAttribute('data-merlons-hierarchy-loading', 'true');
    if (container) container.setAttribute('aria-busy', 'true');

    fetchDocument(categoryHierarchyRequestPath(source, requestedPage), controller ? controller.signal : undefined)
      .then(function (documentNode) {
        if (
          state !== categoryHierarchyState ||
          requestGeneration !== categoryHierarchyGeneration ||
          state.stateKey !== categoryHierarchyStateKey() ||
          state.grid !== document.getElementById('product-grid')
        ) return;

        var sourceGrid = documentNode.getElementById('MerlonsHierarchyCollectionCards');
        if (!sourceGrid) throw new Error('Category hierarchy product cards are missing');
        registerCategoryHierarchyFacets(state, source, documentNode);
        var totalPages = Math.max(0, Number(sourceGrid.getAttribute('data-total-pages') || 0));
        var totalProducts = Math.max(0, Number(sourceGrid.getAttribute('data-total-products') || 0));
        if (!source.totalRegistered) {
          source.totalRegistered = true;
          state.totalEstimate += totalProducts;
        }
        source.totalPages = totalPages;

        var fragment = document.createDocumentFragment();
        var appendedCount = 0;
        sourceGrid.querySelectorAll('.product--item[data-product-id]').forEach(function (item) {
          var id = item.getAttribute('data-product-id');
          if (!id || state.knownIds.has(id)) return;
          state.knownIds.add(id);
          fragment.appendChild(document.importNode(item, true));
          appendedCount += 1;
        });
        state.grid.appendChild(fragment);
        sortCategoryHierarchyItems(state);
        state.pagesLoaded += 1;
        source.nextPage = requestedPage + 1;
        if (source.nextPage <= source.totalPages) {
          if (source.isCurrent) state.queue.unshift(source);
          else state.queue.push(source);
        }

        state.grid.setAttribute('data-current-page', String(Math.max(1, state.pagesLoaded)));
        state.grid.setAttribute('data-total-pages', String(Math.max(state.pagesLoaded, state.pagesLoaded + state.queue.length)));
        state.grid.setAttribute('data-total-products', String(Math.max(state.knownIds.size, state.totalEstimate)));
        updateResultCounts(state.knownIds.size, Math.max(state.knownIds.size, state.totalEstimate));
        if (typeof window.merlonsRebindCollectionCards === 'function') {
          window.merlonsRebindCollectionCards(state.grid);
        }
        document.dispatchEvent(new CustomEvent('merlons:collection:appended', {
          detail: {
            count: appendedCount,
            page: requestedPage,
            url: source.url,
            hierarchy: true
          }
        }));
      })
      .then(function () {
        if (state !== categoryHierarchyState || requestGeneration !== categoryHierarchyGeneration) return;
        state.loading = false;
        state.controller = null;
        state.sentinel.setAttribute('aria-busy', 'false');
        state.sentinel.classList.remove('is-loading', 'is-error');
        state.button.disabled = false;
        state.button.removeAttribute('aria-disabled');
        state.status.textContent = state.labels.loaded || '';
        if (root) root.removeAttribute('data-merlons-hierarchy-loading');
        if (container) container.removeAttribute('aria-busy');
        if (!state.queue.length) {
          finishCategoryHierarchy(state);
          return;
        }
        categoryHierarchyObserve(state);
        if (state.sentinel.getBoundingClientRect().top <= window.innerHeight + 900) {
          window.setTimeout(function () { loadNextCategoryHierarchyPage(state, false); }, 0);
        }
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (state !== categoryHierarchyState || requestGeneration !== categoryHierarchyGeneration) return;
        state.queue.unshift(source);
        state.loading = false;
        state.failed = true;
        state.controller = null;
        state.sentinel.setAttribute('aria-busy', 'false');
        state.sentinel.classList.remove('is-loading');
        state.sentinel.classList.add('is-error');
        state.button.disabled = false;
        state.button.removeAttribute('aria-disabled');
        state.status.textContent = state.labels.error || '';
        if (root) root.removeAttribute('data-merlons-hierarchy-loading');
        if (container) container.removeAttribute('aria-busy');
        console.error('[Merlons category hierarchy]', error);
      });
  }

  function setupCategoryHierarchy() {
    var root = getRoot();
    var grid = document.getElementById('product-grid');
    var params = getSearchParams();
    var localSort = params.get('merlons_sort');
    var offerModes = getSelectedOfferModes(params);
    if (
      !root ||
      !grid ||
      isSearchResultsPage() ||
      !hasCategoryDescendants() ||
      getCurrentQuery() ||
      localSort === 'discount' ||
      localSort === 'liquidation' ||
      offerModes.length
    ) {
      cancelCategoryHierarchy(true);
      return;
    }

    var stateKey = categoryHierarchyStateKey();
    if (
      categoryHierarchyState &&
      categoryHierarchyState.grid === grid &&
      categoryHierarchyState.stateKey === stateKey
    ) return;

    cancelCategoryHierarchy(true);
    if (typeof window.merlonsCancelCollectionInfiniteScroll === 'function') {
      window.merlonsCancelCollectionInfiniteScroll();
    }

    var sources = getCategorySources();
    var currentHandle = root.getAttribute('data-merlons-collection-handle') || '';
    var currentPage = Math.max(1, Number(grid.getAttribute('data-current-page') || 1));
    var currentTotalPages = Math.max(0, Number(grid.getAttribute('data-total-pages') || 0));
    var currentTotalProducts = Math.max(0, Number(grid.getAttribute('data-total-products') || 0));
    var knownIds = new Set();
    grid.querySelectorAll('.product--item[data-product-id]').forEach(function (item) {
      var id = item.getAttribute('data-product-id');
      if (id) knownIds.add(id);
    });
    if (!knownIds.size) grid.innerHTML = '';
    grid.classList.remove('text-center', 'pt-60');
    grid.classList.add('product-collection', 'collection__grid-loadmore', 'row', 'grid--view-items', 'spacing-md-15');

    root.querySelectorAll('.paging, .nov-pagination, .collection__btn-loadmore, .scroll__infinityfilter').forEach(function (element) {
      element.remove();
    });

    var queue = [];
    var sourceStates = sources.map(function (source, index) {
      var isCurrent = source.handle === currentHandle || index === 0;
      var sourceState = {
        handle: source.handle,
        url: source.url,
        isCurrent: isCurrent,
        nextPage: isCurrent ? currentPage + 1 : 1,
        totalPages: isCurrent ? currentTotalPages : null,
        totalRegistered: isCurrent
      };
      if (!isCurrent || sourceState.nextPage <= sourceState.totalPages) queue.push(sourceState);
      return sourceState;
    });

    var sentinel = document.createElement('div');
    var button = document.createElement('button');
    var status = document.createElement('span');
    var labels = categoryHierarchyLabels();
    sentinel.className = 'merlons-infinite-scroll merlons-category-hierarchy-scroll text-center mt-30';
    sentinel.setAttribute('data-merlons-category-hierarchy-scroll', '');
    sentinel.setAttribute('aria-busy', 'false');
    button.type = 'button';
    button.className = 'btn merlons-infinite-scroll__fallback merlons-category-hierarchy-scroll__fallback';
    button.textContent = labels.button || labels.loading || '';
    status.className = 'merlons-infinite-scroll__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    sentinel.appendChild(button);
    sentinel.appendChild(status);
    var bottom = root.querySelector('.collection-loadmore__bottom');
    if (bottom) bottom.appendChild(sentinel);
    else grid.insertAdjacentElement('afterend', sentinel);

    var state = {
      generation: categoryHierarchyGeneration,
      stateKey: stateKey,
      grid: grid,
      sources: sourceStates,
      queue: queue,
      knownIds: knownIds,
      facetSources: new Map(),
      canonicalFacetData: canonicalCategoryHierarchyFacetData(),
      totalEstimate: currentTotalProducts,
      pagesLoaded: currentPage,
      sortMode: params.get('sort_by') || '',
      sentinel: sentinel,
      button: button,
      status: status,
      labels: labels,
      observer: null,
      controller: null,
      loading: false,
      failed: false,
      hierarchyComplete: false
    };
    categoryHierarchyState = state;
    renderCategoryHierarchyFacets(state);
    updateResultCounts(knownIds.size, Math.max(knownIds.size, currentTotalProducts));
    button.addEventListener('click', function () { loadNextCategoryHierarchyPage(state, true); });
    if ('IntersectionObserver' in window && typeof window.fetch === 'function' && typeof window.DOMParser === 'function') {
      sentinel.classList.add('is-enhanced');
      state.observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          loadNextCategoryHierarchyPage(state, false);
        }
      }, { rootMargin: '900px 0px' });
      categoryHierarchyObserve(state);
    }
    if (!state.queue.length) finishCategoryHierarchy(state);
    else if (!knownIds.size) loadNextCategoryHierarchyPage(state, false);
  }

  function finishQueryInfiniteScroll(state) {
    if (!state || state !== queryInfiniteState) return;
    if (state.observer) state.observer.disconnect();
    state.loading = false;
    state.sentinel.setAttribute('aria-busy', 'false');
    state.sentinel.classList.remove('is-loading', 'is-error');
    state.sentinel.classList.add('is-complete');
    state.button.disabled = true;
    state.button.setAttribute('aria-disabled', 'true');
    state.button.textContent = state.labels.complete || state.labels.loaded || state.labels.button;
    state.status.textContent = state.labels.complete || '';
  }

  function appendQueryItems(state) {
    if (
      !state ||
      state !== queryInfiniteState ||
      state.loading ||
      state.requestId !== activeSearchRequest ||
      state.query !== getCurrentQuery() ||
      !state.grid.isConnected
    ) return;
    if (state.rendered >= state.items.length) {
      finishQueryInfiniteScroll(state);
      return;
    }

    state.loading = true;
    state.sentinel.setAttribute('aria-busy', 'true');
    state.sentinel.classList.remove('is-error', 'is-complete');
    state.sentinel.classList.add('is-loading');
    state.button.disabled = true;
    state.status.textContent = state.labels.loading || '';

    window.requestAnimationFrame(function () {
      if (
        state !== queryInfiniteState ||
        state.requestId !== activeSearchRequest ||
        state.query !== getCurrentQuery() ||
        !state.grid.isConnected
      ) return;
      try {
        var end = Math.min(state.items.length, state.rendered + state.batchSize);
        var markup = state.items.slice(state.rendered, end).map(function (item) {
          return item.markup;
        }).join('');
        state.grid.insertAdjacentHTML('beforeend', markup);
        state.rendered = end;
        state.grid.setAttribute('data-current-page', String(Math.max(1, Math.ceil(end / state.batchSize))));
        updateResultCounts(end, state.items.length);
        if (typeof window.merlonsRebindCollectionCards === 'function') {
          window.merlonsRebindCollectionCards(state.grid);
        }
        state.loading = false;
        state.sentinel.setAttribute('aria-busy', 'false');
        state.sentinel.classList.remove('is-loading', 'is-error');
        if (end >= state.items.length) {
          finishQueryInfiniteScroll(state);
        } else {
          state.button.disabled = false;
          state.button.removeAttribute('aria-disabled');
          state.status.textContent = state.labels.loaded || '';
        }
      } catch (error) {
        state.loading = false;
        state.sentinel.setAttribute('aria-busy', 'false');
        state.sentinel.classList.remove('is-loading');
        state.sentinel.classList.add('is-error');
        state.button.disabled = false;
        state.button.removeAttribute('aria-disabled');
        state.status.textContent = state.labels.error || getStatusLabel('data-merlons-search-error-label');
        console.error('[Merlons collection search pagination]', error);
      }
    });
  }

  function createQueryInfiniteScroll(grid, items, renderedCount, query, requestId, labels) {
    var bottom = document.querySelector('#main-collection-filters .collection-loadmore__bottom');
    if (renderedCount >= items.length) return;

    var sentinel = document.createElement('div');
    var button = document.createElement('button');
    var status = document.createElement('span');
    sentinel.className = 'merlons-infinite-scroll merlons-query-infinite-scroll text-center mt-30';
    sentinel.setAttribute('data-merlons-query-infinite-scroll', '');
    sentinel.setAttribute('aria-busy', 'false');
    button.type = 'button';
    button.className = 'btn merlons-infinite-scroll__fallback merlons-query-infinite-scroll__fallback';
    button.textContent = labels.button || labels.loading || '';
    status.className = 'merlons-infinite-scroll__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    sentinel.appendChild(button);
    sentinel.appendChild(status);
    if (bottom) bottom.appendChild(sentinel);
    else grid.insertAdjacentElement('afterend', sentinel);

    var state = {
      observer: null,
      sentinel: sentinel,
      button: button,
      status: status,
      grid: grid,
      items: items,
      rendered: renderedCount,
      batchSize: getQueryBatchSize(),
      query: query,
      requestId: requestId,
      labels: labels,
      loading: false
    };
    queryInfiniteState = state;
    button.addEventListener('click', function () { appendQueryItems(state); });
    if ('IntersectionObserver' in window) {
      sentinel.classList.add('is-enhanced');
      state.observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) appendQueryItems(state);
      }, { rootMargin: '900px 0px' });
      state.observer.observe(sentinel);
    }
  }

  function renderSearchItems(items, query, requestId) {
    if (requestId !== activeSearchRequest || query !== getCurrentQuery()) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var root = getRoot();
    var labels = captureQueryPaginationLabels();
    var batchSize = getQueryBatchSize();
    var renderedItems = items.slice(0, batchSize);

    cancelQueryInfiniteScroll(true);

    grid.innerHTML = renderedItems.map(function (item) { return item.markup; }).join('');
    if (!items.length) {
      var empty = document.createElement('div');
      var heading = document.createElement('h2');
      empty.className = 'merlons-collection-search-empty col-12 text-center';
      heading.className = 'mb-0';
      heading.textContent = root ? root.getAttribute('data-merlons-empty-label') || '' : '';
      empty.appendChild(heading);
      grid.appendChild(empty);
    }
    grid.removeAttribute('data-next-url');
    grid.setAttribute('data-current-page', '1');
    grid.setAttribute('data-total-pages', String(Math.max(1, Math.ceil(items.length / batchSize))));
    grid.setAttribute('data-total-products', String(items.length));
    document.querySelectorAll('#main-collection-filters .collection__btn-loadmore, #main-collection-filters .scroll__infinityfilter, #main-collection-filters .paging, #main-collection-filters .nov-pagination').forEach(function (element) {
      element.remove();
    });
    updateResultCounts(renderedItems.length, items.length);
    if (typeof window.merlonsRebindCollectionCards === 'function') window.merlonsRebindCollectionCards(grid);
    setStatus(getStatusLabel('data-merlons-search-results-label', items.length));
    createQueryInfiniteScroll(grid, items, renderedItems.length, query, requestId, labels);
  }

  function finishSearchUI(requestId) {
    if (requestId !== activeSearchRequest) return;
    var container = document.getElementById('CollectionProductContainer');
    var root = getRoot();
    if (container) container.removeAttribute('aria-busy');
    if (root) root.removeAttribute('data-merlons-search-loading');
  }

  window.merlonsCancelCollectionSearch = function () {
    activeSearchRequest += 1;
    if (activeSearchController) activeSearchController.abort();
    activeSearchController = null;
    cancelQueryInfiniteScroll(true);
    finishSearchUI(activeSearchRequest);
  };

  window.merlonsApplyCollectionSearch = function (queryValue) {
    var query = normalizeQuery(queryValue == null ? getCurrentQuery() : queryValue);
    if (!query) {
      window.merlonsCancelCollectionSearch();
      setStatus('');
      syncSearchInput();
      return Promise.resolve();
    }

    if (typeof window.merlonsCancelCollectionInfiniteScroll === 'function') {
      window.merlonsCancelCollectionInfiniteScroll();
    }
    cancelCategoryHierarchy(true);
    cancelQueryInfiniteScroll(true);
    if (activeSearchController) activeSearchController.abort();
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    activeSearchController = controller;
    var signal = controller ? controller.signal : undefined;
    var requestId = ++activeSearchRequest;
    var root = getRoot();
    var container = document.getElementById('CollectionProductContainer');
    if (container) container.setAttribute('aria-busy', 'true');
    if (root) root.setAttribute('data-merlons-search-loading', 'true');
    setStatus(getStatusLabel('data-merlons-search-loading-label'));
    syncSearchInput();

    var categorySources = getCategorySources();
    var allowedCategoryHandles = new Set(categorySources.map(function (source) { return source.handle; }).filter(Boolean));
    var membershipPromise = Promise.resolve(null);

    return Promise.all([
      membershipPromise,
      fetchSearchProductItems(query, signal)
    ]).then(function (values) {
      if (requestId !== activeSearchRequest || query !== getCurrentQuery()) return;
      var allItems = values[0];
      var cardItems = values[1];
      var mode = getSearchParams().get('merlons_sort');
      var offerModes = getSelectedOfferModes();
      var visibleItems;

      if (allItems) {
        visibleItems = allItems.map(function (item) {
          var cardItem = cardItems.get(item.id);
          if (!cardItem) return null;
          return {
            id: item.id,
            markup: cardItem.markup,
            discountRatio: item.discountRatio,
            isDiscounted: item.isDiscounted,
            isLiquidation: item.isLiquidation
          };
        }).filter(Boolean);
      } else if (isAllProductsCollection()) {
        visibleItems = Array.from(cardItems.values());
      } else {
        // Search cards carry their Shopify collection memberships. Intersecting
        // those memberships with the selected category's inclusive source list
        // avoids crawling every descendant collection before results appear.
        visibleItems = Array.from(cardItems.values()).filter(function (item) {
          if (!item.collectionHandlesKnown) return false;
          return item.collectionHandles.some(function (handle) {
            return allowedCategoryHandles.has(handle);
          });
        });
      }

      visibleItems = visibleItems.filter(function (item) {
        if (offerModes.length) {
          return offerModes.some(function (offerMode) {
            return offerMode === 'discount' ? item.isDiscounted : item.isLiquidation;
          });
        }
        if (mode === 'discount') return item.isDiscounted;
        if (mode === 'liquidation') return item.isLiquidation;
        return true;
      });
      if (!visibleItems.length) {
        renderSearchItems([], query, requestId);
        return null;
      }
      if (mode === 'discount' || mode === 'liquidation') {
        visibleItems.sort(function (a, b) { return b.discountRatio - a.discountRatio; });
      }
      renderSearchItems(visibleItems, query, requestId);
      return null;
    }).catch(function (error) {
      if (error && error.name === 'AbortError') return;
      if (requestId !== activeSearchRequest) return;
      console.error('[Merlons collection search]', error);
      setStatus(getStatusLabel('data-merlons-search-error-label'));
    }).finally(function () {
      finishSearchUI(requestId);
    });
  };

  function submitSearch(queryValue, source) {
    var params = getSearchParams();
    var query = normalizeQuery(queryValue);
    if (query) params.set('q', query);
    else params.delete('q');
    if (isSearchResultsPage() && query) {
      params.set('type', 'product');
      params.set('options[prefix]', 'last');
    } else {
      params.delete('options[prefix]');
      if (isSearchResultsPage()) params.delete('type');
    }
    params.delete('page');
    var filterElement = document.querySelector('collection-filter-product');
    if (filterElement && typeof filterElement.onSubmitForm === 'function') {
      filterElement.onSubmitForm(params.toString(), source || null);
      return;
    }
    var nextSearch = params.toString();
    window.location.assign(window.location.pathname + (nextSearch ? '?' + nextSearch : ''));
  }

  function onDocumentClick(event) {
    var root = getRoot();
    if (!root) return;
    var categoryTrigger = event.target.closest('[data-merlons-category-trigger]');
    if (categoryTrigger && root.contains(categoryTrigger)) {
      event.preventDefault();
      openCategorySheet(categoryTrigger);
      return;
    }
    if (event.target.closest('[data-merlons-category-close]') || event.target.closest('[data-merlons-category-backdrop]')) {
      event.preventDefault();
      closeCategorySheet();
      return;
    }
    var trigger = event.target.closest('[data-merlons-filter-trigger]');
    if (trigger && root.contains(trigger)) {
      event.preventDefault();
      openFilterSheet(trigger);
      return;
    }
    if (event.target.closest('[data-merlons-filter-close]') || event.target.closest('[data-merlons-filter-backdrop]')) {
      event.preventDefault();
      closeFilterSheet();
      return;
    }
    var clear = event.target.closest('[data-merlons-collection-search-clear]');
    if (clear && root.contains(clear)) {
      event.preventDefault();
      var input = root.querySelector('[data-merlons-collection-search-input]');
      if (input) input.value = '';
      clear.hidden = true;
      submitSearch('', clear);
      if (input) input.focus({ preventScroll: true });
      return;
    }

    var selectedSortItem = event.target.closest('[data-sortby-item]');
    if (selectedSortItem && root.contains(selectedSortItem)) {
      window.setTimeout(syncSortAccessibility, 0);
      return;
    }
    var sortTrigger = event.target.closest('.merlons-collection-sorter__trigger');
    if (sortTrigger && root.contains(sortTrigger)) {
      window.setTimeout(syncSortAccessibility, 0);
      return;
    }
    root.querySelectorAll('[data-sortby-filter].act').forEach(function (sorter) {
      if (!sorter.contains(event.target)) closeSortDropdown(sorter, false);
    });
  }

  function onDocumentSubmit(event) {
    var form = event.target.closest('[data-merlons-collection-search-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('[data-merlons-collection-search-input]');
    submitSearch(input ? input.value : '', input || form);
  }

  function onDocumentInput(event) {
    if (!event.target.matches('[data-merlons-collection-search-input]')) return;
    var form = event.target.closest('[data-merlons-collection-search-form]');
    var clear = form && form.querySelector('[data-merlons-collection-search-clear]');
    if (clear) clear.hidden = !normalizeQuery(event.target.value);
  }

  function onDocumentKeydown(event) {
    var root = getRoot();
    if (!root) return;
    if (event.key === 'Enter' && event.target.matches('[data-merlons-collection-search-input]')) {
      event.preventDefault();
      submitSearch(event.target.value, event.target);
      return;
    }
    var categorySheet = root.querySelector('[data-merlons-category-sheet].is-open');
    if (categorySheet) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeCategorySheet();
        return;
      }
      trapSheetFocus(event, categorySheet);
      return;
    }
    var sheet = root.querySelector('[data-merlons-filter-sheet].is-open');
    if (sheet) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeFilterSheet();
        return;
      }
      trapSheetFocus(event, sheet);
      return;
    }

    var trigger = event.target.closest('.merlons-collection-sorter__trigger');
    if (trigger && event.key === 'Escape') {
      event.preventDefault();
      closeSortDropdown(trigger.closest('[data-sortby-filter]'), true);
      return;
    }
    if (trigger && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      event.preventDefault();
      var sorter = trigger.closest('[data-sortby-filter]');
      if (!trigger.classList.contains('act')) trigger.click();
      window.setTimeout(function () {
        var items = Array.prototype.slice.call(sorter.querySelectorAll('[data-sortby-item]'));
        var target = event.key === 'ArrowUp' ? items[items.length - 1] : items[0];
        if (target) target.focus({ preventScroll: true });
        syncSortAccessibility();
      }, 0);
      return;
    }

    var sortItem = event.target.closest('[data-sortby-item]');
    if (sortItem) {
      var sortContainer = sortItem.closest('[data-sortby-filter]');
      var options = Array.prototype.slice.call(sortContainer.querySelectorAll('[data-sortby-item]'));
      var currentIndex = options.indexOf(sortItem);
      var nextIndex = currentIndex;
      if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % options.length;
      else if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + options.length) % options.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = options.length - 1;
      else if (event.key === 'Escape') {
        event.preventDefault();
        closeSortDropdown(sortContainer, true);
        return;
      } else return;
      event.preventDefault();
      options[nextIndex].focus({ preventScroll: true });
    }
  }

  function refreshCollectionEnhancements() {
    observeMountingFilterOrder();
    syncSearchInput();
    syncSortAccessibility();
    if (isSearchResultsPage()) {
      cancelCategoryHierarchy(true);
      window.merlonsCancelCollectionSearch();
      setStatus('');
      queueStickyOffsetSync();
      return;
    }
    var query = getCurrentQuery();
    if (query) window.merlonsApplyCollectionSearch(query);
    else {
      window.merlonsCancelCollectionSearch();
      setStatus('');
      setupCategoryHierarchy();
    }
    queueStickyOffsetSync();
  }

  function targetsCollectionSection(event) {
    if (!event || !event.target || event.target === document) return true;
    var target = event.target;
    if (target.matches && target.matches('#main-collection-filters')) return true;
    if (target.querySelector && target.querySelector('#main-collection-filters')) return true;
    var root = getRoot();
    return Boolean(root && (
      target === root ||
      (target.contains && target.contains(root)) ||
      (root.contains && root.contains(target))
    ));
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('submit', onDocumentSubmit);
  document.addEventListener('input', onDocumentInput);
  document.addEventListener('keydown', onDocumentKeydown);
  document.addEventListener('merlons:collection:rendered', refreshCollectionEnhancements);
  document.addEventListener('shopify:section:load', function (event) {
    if (targetsCollectionSection(event)) refreshCollectionEnhancements();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!targetsCollectionSection(event)) return;
    disconnectMountingFilterOrderObserver();
    closeFilterSheet({ restoreFocus: false });
    closeCategorySheet({ restoreFocus: false });
    cancelCategoryHierarchy(true);
    window.merlonsCancelCollectionSearch();
  });
  window.addEventListener('popstate', function () {
    closeFilterSheet({ restoreFocus: false });
    closeCategorySheet({ restoreFocus: false });
    window.setTimeout(syncSearchInput, 0);
  });
  window.addEventListener('scroll', queueStickyOffsetSync, { passive: true });
  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 1200px)').matches) {
      closeCategorySheet({ restoreFocus: false });
    }
    queueStickyOffsetSync();
  });
  document.addEventListener('transitionend', function (event) {
    if (event.target.closest && event.target.closest('#header-sticky, .header-mobile')) queueStickyOffsetSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCollectionEnhancements, { once: true });
  } else {
    refreshCollectionEnhancements();
  }
})();
